import {
  CloseCircleOutlined,
  DeleteOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
  ScheduleFilled,
} from "@ant-design/icons";
import ApiCalendar from "../../api/backend/calendar";

import BoxContent from "@src/component/Desktop/content";

import {
  Alert,
  Button,
  Col,
  Collapse,
  DatePicker,
  Input,
  Modal,
  Row,
  Select,
  Table,
} from "antd";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useHistory, useParams } from "react-router-dom";
import kbn from "../../api/backend/kbn";
import Loading from "../../component/Desktop/loading/loading";
import TitlePage from "../../component/Desktop/titlePage";
import FooterPage from "../../component/footer/footerPage";
import {
  COMMON_CONSTANT,
  HOLIDAY_TYPE,
  KEY,
  lang,
  STYLE,
} from "../../constants/common.const";
import {
  handleCatchError,
  renderOption,
  showMessage,
} from "../../constants/utils";
import classDdl from "../../models/control/dropdownlist";
import classText from "../../models/control/text";
import { ColorPicker } from "../DynamicChartManagement/add";
import "./calendar.scss";

const { Panel } = Collapse;

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const isDateRangeConflict = (startDate, endDate, dataSource, callback) => {
  const listError = dataSource.filter((item) => {
    const itemStart = moment(item.startDate);
    const itemEnd = moment(item.endDate);
    return (
      (startDate.isBetween(itemStart, itemEnd, null, "[]") ||
        endDate.isBetween(itemStart, itemEnd, null, "[]")) &&
      !(startDate.isSame(itemStart) && endDate.isSame(itemEnd))
    );
  });
  if (listError.length > 0) {
    callback(listError.map((i) => i.key));
  }

  return listError.length > 0;
};

const checkDuplicate = (startDate, endDate, dataSource, callback) => {
  const dulicateData = dataSource.filter(
    (item) =>
      moment(item.startDate).isSame(startDate) &&
      moment(item.endDate).isSame(endDate)
  );
  const duplicateCount = dulicateData.length;

  if (duplicateCount >= 2) {
    callback(dulicateData.map((i) => i.key));
  }

  return duplicateCount >= 2;
};

function CustomDayOff({ isEndUser }) {
  const MESS_ERROR = {
    EMPTY_TYPE: "休暇の種類を入力してください。",
    EMPTY_NAME: "休日名称を入力してください。",
    EMPTY_DATE: "期間を入力してください。",
    OVERLAP:"重ねる期間が存在しています。"
  };
  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });
  const { id } = useParams();
  const history = useHistory();
  const [showLoading, setShowLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [optionTime, setOptionTime] = useState([]);
  const [listHolidayType, setListHolidayType] = useState([]);
  const [isDirty, setDirtyFormTable] = useState(false);
  const [error, setError] = useState("");
  const errorRefs = useRef({});
  const errorNameRef = useRef({});
  const errorTypeRef = useRef({});

  const handleDateChange = (key, dateType, date) => {
    const newDataSource = dataSource.map((item) => {
      if (item.key === key) {
        item[dateType] = date ? date.format("YYYY-MM-DD") : "";
      }
      return item;
    });
    setDataSource(newDataSource);
  };

  const callBackCheckError =
    (list) =>
    (listErrId = []) => {
      list.push(...listErrId);
    };
  const validateData = () => {
    let hasError = false;
    let errorMessage = "";
    const listKeyError = [];
    const newDataSource = dataSource.map((item) => {
      const startDate = moment(item.startDate);
      const endDate = moment(item.endDate);

      let startDateCheckType = startDate;
      let endDateCheckType = endDate;
      let cloneDataSource = JSON.parse(JSON.stringify(dataSource));
      let dataCheck1 = JSON.parse(JSON.stringify(dataSource));
      let dataCheck2 = JSON.parse(JSON.stringify(dataSource));

      // Check yearly
      if (item.type && item.type.value == HOLIDAY_TYPE.YEARLY) {
        const currentYear = startDate.year();
        startDateCheckType = moment(startDateCheckType)
          .set("year", currentYear)
          .format("YYYY-MM-DD");
        endDateCheckType = moment(endDateCheckType)
          .set("year", currentYear)
          .format("YYYY-MM-DD");

        // Filter yealy or start year = end year or endyear - start year >=2
        const filterFunc = (item) => {
          const start = moment(item.startDate);
          const end = moment(item.endDate);
          if (!start.isValid() || !end.isValid()) {
            return false;
          }
          return (
            (item.type && item.type.value == HOLIDAY_TYPE.YEARLY) ||
            (item.type &&
              item.type.value != HOLIDAY_TYPE.YEARLY &&
              (start.year() === end.year() || end.year() - start.year() >= 2))
          );
        };

        const filterFunc2 = (item) => {
          const start = moment(item.startDate);
          const end = moment(item.endDate);
          if (!start.isValid() || !end.isValid()) {
            return false;
          }
          return (
            item.type &&
            item.type.value != HOLIDAY_TYPE.YEARLY &&
            end.year() - start.year() == 1
          );
        };

        cloneDataSource = cloneDataSource.filter(filterFunc).map((item) => ({
          ...item,
          startDate: moment(item.startDate)
            .set("year", currentYear)
            .format("YYYY-MM-DD"),
          endDate: moment(item.endDate)
            .set("year", currentYear)
            .format("YYYY-MM-DD"),
        }));

        // Check range 1
        dataCheck1 = dataCheck1.filter(filterFunc2).map((item) => ({
          ...item,
          startDate: moment(item.startDate)
            .set("year", currentYear)
            .format("YYYY-MM-DD"),
          endDate: moment(`${currentYear}-12-31`).format("YYYY-MM-DD"),
        }));
        // Check range 1
        dataCheck2 = dataCheck2.filter(filterFunc2).map((item) => ({
          ...item,
          startDate: moment(`${currentYear}-01-01`).format("YYYY-MM-DD"),
          endDate: moment(item.endDate)
            .set("year", currentYear)
            .format("YYYY-MM-DD"),
        }));
      }

      if (!startDate.isValid() || !endDate.isValid()) {
        if (!startDate.isValid()) {
          item.errorStart = true;
        }
        if (!endDate.isValid()) {
          item.errorEnd = true;
        }
        hasError = true;
        errorMessage = errorMessage +  MESS_ERROR.EMPTY_DATE + '\n';
        item.error = true;
      } else if (
        isDateRangeConflict(
          startDate,
          endDate,
          cloneDataSource,
          callBackCheckError(listKeyError)
        ) ||
        checkDuplicate(
          startDate,
          endDate,
          cloneDataSource,
          callBackCheckError(listKeyError)
        ) ||
        isDateRangeConflict(
          startDate,
          endDate,
          dataCheck1,
          callBackCheckError(listKeyError)
        ) ||
        checkDuplicate(
          startDate,
          endDate,
          dataCheck1,
          callBackCheckError(listKeyError)
        ) ||
        isDateRangeConflict(
          startDate,
          endDate,
          dataCheck2,
          callBackCheckError(listKeyError)
        ) ||
        checkDuplicate(
          startDate,
          endDate,
          dataCheck2,
          callBackCheckError(listKeyError)
        )
      ) {
        hasError = true;
        errorMessage = errorMessage + MESS_ERROR.OVERLAP + "\n";
        item.error = true;
        item.errorStart = true;
        item.errorEnd = true;
      } else {
        item.error = false;
        item.errorStart = false;
        item.errorEnd = false;
      }

      // Check error name
      if (
        !item.dayOffName.value.trim() ||
        checkDuplicateHoliDay(item, dataSource)
      ) {
        item.dayOffName.error = true;
        if (item.dayOffName.value.trim()) {
          errorMessage = errorMessage +  "休日名が重複しています。\n";
        }
        else{
          errorMessage = errorMessage + MESS_ERROR.EMPTY_NAME + '\n'
        }
      } else {
        item.dayOffName.error = false;
      }
      // Check error type
      if (!item.type || (item.type && !item.type.value)) {
        item.type.error = true;
        errorMessage = errorMessage + MESS_ERROR.EMPTY_TYPE + "\n";
      } else {
        item.type.error = false;
      }
      return item;
    });
    newDataSource.forEach((item) => {
      if (item.type && item.type.value != HOLIDAY_TYPE.YEARLY) {
        if (listKeyError.find((key) => key == item.key)) {
          item.error = true;
          item.errorStart = true;
          item.errorEnd = true;
        } else if (!item.startDate) {
          item.error = true;
          item.errorStart = true;
        } else if (!item.endDate) {
          item.error = true;
          item.errorEnd = true;
        } else {
          item.error = false;
          item.errorStart = false;
          item.errorEnd = false;
        }
      }
    });
    setDataSource(newDataSource);
    setError(errorMessage);

    if (hasError) {
      const firtErrorItem = newDataSource.find((item) => item.error) || {};
      const firstErrorKey = firtErrorItem.key;
      if (errorRefs.current[firstErrorKey]) {
        errorRefs.current[firstErrorKey].focus();
      }
    }

    // Error name
    const listErrorNameDayOf = newDataSource.filter((i) => i.dayOffName.error);
    const isErrorName = listErrorNameDayOf.length > 0;
    if (isErrorName) {
      const firstErrorKey = listErrorNameDayOf[0].key;
      if (errorNameRef.current[firstErrorKey]) {
        errorNameRef.current[firstErrorKey].focus();
      }
    }
    // Error type
    const listErrorType = newDataSource.filter((i) => i.type.error);
    const isErrorType = listErrorType.length > 0;
    if (isErrorType) {
      const firstErrorKey = listErrorType[0].key;
      if (errorTypeRef.current[firstErrorKey]) {
        errorTypeRef.current[firstErrorKey].focus();
      }
    }

    return !hasError && !isErrorName && !isErrorType;
  };

  const checkDuplicateHoliDay = (itemRow, dataSource) => {
    return (
      dataSource.filter(
        (item) =>
          item.dayOffName.value.trim() === itemRow.dayOffName.value.trim()
      ).length >= 2
    );
  };

  // GET LIST HOLIDAY
  const getInit = async () => {
    try {
      setShowLoading(true);
      const res = await Promise.all([
        ApiCalendar.getListDayOff(),
        kbn.getHolidayType(),
      ]);
      const holidayData = res[0].data;
      const listType = res[1].data.data;
      setDataSource(
        holidayData.map((item) => ({
          key: item.id,
          startDate: item.startDate,
          endDate: item.endDate,
          dayOffName: new classText(item.name),
          color: item.color || getRandomColor(),
          error: false,
          id: item.id,
          type: new classDdl(item.type),
        }))
      );
      setListHolidayType(listType || []);
    } catch (error) {
      handleCatchError(error);
    } finally {
      setShowLoading(false);
    }
  };

  useEffect(() => {
    getInit();
  }, []);

  // SAVE
  const onSaveData = async () => {
    try {
      setShowLoading(true);

      const dataPost = dataSource.map(
        ({ key, error, dayOffName, type, ...other }) => ({
          ...other,
          name: dayOffName.value,
          type: type.value,
        })
      );

      await ApiCalendar.addListDayOff(dataPost);
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, () => {
        getInit();
      });
    } catch (error) {
      handleCatchError(error);
    } finally {
      setShowLoading(false);
    }
  };
  // Popup common
  const showConfirmMessage = (
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    let ok, cancel;
    const callBackDefault = () => {
      Modal.destroyAll();
    };

    // Callback OK exist
    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }
    // Callback Cancel exist
    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      centered: true,
      icon: <QuestionCircleOutlined />,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };
  const handleSave = () => {
    if (!validateData()) {
      return;
    }
    showConfirmMessage(COMMON_CONSTANT.BOM_C008, onSaveData);
  };

  // Change TYPE
  const changeTypeHoliday = (key) => (value) => {
    const newData = [...dataSource];
    const index = newData.findIndex((i) => i.key == key);
    if (index >= 0) {
      newData[index].type.value = value;
      setDataSource(newData);
    }
  };
  const columns = [
    {
      title: " ",
      dataIndex: "delete",
      width: "5%",
      render: (_, row) => {
        return (
          <Button
            style={{ background: "#f7f9fc" }}
            onClick={() => handleDeleteRow(row.key)}
            icon={<DeleteOutlined />}
          />
        );
      },
    },
    {
      title: lang.DAY_OFF_TYPE,
      dataIndex: "delete",
      width: "15%",
      render: (_, row) => {
        return (
          <Select
            ref={(el) => (errorTypeRef.current[row.key] = el)}
            onChange={changeTypeHoliday(row.key)}
            value={row.type.value}
            className={
              (row.type.error ? STYLE.BORDER_RED : "") + " w100 holidayType"
            }
          >
            {renderOption(listHolidayType, false)}
          </Select>
        );
      },
    },
    {
      title: lang.DAY_OFF_NAME,
      dataIndex: "dayOffName",
      width: "25%",
      textAlign: "center",
      render: (value, row) => {
        return (
          <Input
            style={{
              borderColor: row.dayOffName.error ? "red" : undefined,
            }}
            ref={(el) => (errorNameRef.current[row.key] = el)}
            onChange={(e) => {
              const dayOffItemIndex = dataSource.findIndex(
                (i) => i.key == row.key
              );
              if (dayOffItemIndex < 0) {
                return;
              }
              const newData = JSON.parse(JSON.stringify(dataSource));
              newData[dayOffItemIndex].dayOffName.value = e.target.value;
              setDataSource(newData);
            }}
            value={row.dayOffName.value}
            type="text"
          />
        );
      },
    },
    {
      title: lang.DAY_OFF,
      dataIndex: "dayOff",
      width: "50%",
      textAlign: "center",
      render: (value, row) => {
        const startDate = moment(row.startDate);
        const endDate = moment(row.endDate);

        return (
          <Row align="middle">
            <Col span={24}>
              <Row>
                <Col span={11}>
                  <DatePicker
                    style={{ borderColor: row.errorStart ? "red" : undefined }}
                    className="w100"
                    value={startDate.isValid() ? startDate : null}
                    onChange={(date) =>
                      handleDateChange(row.key, "startDate", date)
                    }
                    disabledDate={(current) => {
                      if (row.type && row.type.value == HOLIDAY_TYPE.YEARLY) {
                        return (
                          (endDate.isValid() && current && current > endDate) ||
                          (endDate.isValid() &&
                            current &&
                            current.year() != endDate.year())
                        );
                      }
                      return endDate.isValid() && current && current > endDate;
                    }}
                    ref={(el) => (errorRefs.current[row.key] = el)}
                  />
                </Col>
                <Col span={2} className="center" style={{ padding: "7px" }}>
                  ~
                </Col>
                <Col span={11}>
                  <DatePicker
                    style={{ borderColor: row.errorEnd ? "red" : undefined }}
                    className="w100"
                    value={endDate.isValid() ? endDate : null}
                    onChange={(date) =>
                      handleDateChange(row.key, "endDate", date)
                    }
                    disabledDate={(current) => {
                      if (row.type && row.type.value == HOLIDAY_TYPE.YEARLY) {
                        return (
                          (startDate.isValid() &&
                            current &&
                            current < startDate) ||
                          (startDate.isValid() &&
                            current &&
                            current.year() != startDate.year())
                        );
                      }
                      return (
                        startDate.isValid() && current && current < startDate
                      );
                    }}
                    ref={(el) => (errorRefs.current[row.key] = el)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        );
      },
    },
    {
      title: "色",
      dataIndex: "color",
      width: "10%",
      textAlign: "center",
      render: (value, row) => {
        if (!value) {
          onChangeFilledInputColumn(row.key, "color", getRandomColor());
        }
        return (
          <ColorPicker
            color={value}
            onChange={(color) => {
              onChangeFilledInputColumn(row.key, "color", color);
            }}
          />
        );
      },
    },
  ];

  const onChangeFilledInputColumn = (key, nameColumn, newValue) => {
    if (isDirty) {
      setDirtyFormTable(false);
    }
    const index = dataSource.findIndex((item) => item.key === key);
    const newObject = {
      [nameColumn]: newValue,
    };
    const newDataSource = [
      ...dataSource.slice(0, index),
      { ...dataSource[index], ...newObject },
      ...dataSource.slice(index + 1),
    ];
    setDataSource(newDataSource);
  };

  const handleDeleteRow = (key) => {
    const newDataSource = dataSource.filter((item) => {
      return item.key !== key;
    });
    setDataSource(newDataSource);
  };

  const handleAddRow = () => {
    const key = Date.now();
    const newRow = {
      key,
      startDate: "",
      endDate: "",
      dayOffName: new classText(),
      color: "",
      error: false,
      type: new classDdl(),
      errorStart: false,
      errorEnd: false,
    };
    setDataSource([...dataSource, newRow]);
  };

  // ListMessError
  const listMessError = Array.from(new Set(error.split('\n'))).sort((mess1,mess2) => {
    const listMess = Object.values(MESS_ERROR);
    const index1 = listMess.findIndex(mess => mess === mess1);
    const index2 = listMess.findIndex(mess => mess === mess2);
    return index1 - index2
  }).map(i => <div>{i}</div>)

  return (
    <div className="des-content dynamic-chart-content">
      <Loading show={showLoading}></Loading>
      <TitlePage name={lang.DAY_OFF_MANAGE} />
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <BoxContent className="p0">
        <div className="mb10">
        {error && <Alert message={listMessError} type="error" showIcon />}
        </div>

            <Collapse defaultActiveKey={["1"]} expandIconPosition="right">
              <Panel
                header={
                  <>
                    <ScheduleFilled className="first-icon" variant="Bold" />
                    {lang.DAY_OFF_SETTING}
                  </>
                }
                key="1"
              >
                <Table
                  scroll={dataSource && dataSource.length > 0 && { x: 1200 }}
                  locale={{
                    emptyText: "",
                  }}
                  pagination={false}
                  dataSource={dataSource}
                  className="tableAddMachine"
                  columns={columns}
                />
                <div className="mt8">
                  <Button
                    style={{
                      background: "#f7f9fc",
                      width: "auto",
                      minWidth: "auto",
                    }}
                    className="pr10 pl10 mt4 mb4 ml10"
                    onClick={() => handleAddRow()}
                    icon={<PlusOutlined />}
                  >
                    {lang.ADD}
                  </Button>
                </div>
              </Panel>
            </Collapse>
          </BoxContent>
        </Col>
      </Row>
      <FooterPage>
        <Row justify="end">
          <Col>
            <Button
              className="buttonPC button--info wAuto ml10"
              onClick={handleSave}
            >
              <SaveOutlined />
              {lang.SAVE}
            </Button>
          </Col>
          <Col>
            <Button
              className="buttonPC button--outline --todo-- wAuto ml15"
              onClick={() => {
                getInit();
              }}
            >
              <CloseCircleOutlined />
              {lang.CANCEL}
            </Button>
          </Col>
        </Row>
      </FooterPage>
    </div>
  );
}

export default CustomDayOff;
